import DefaultLayout from '@/layouts/DefaultLayout.vue'

const Dictresult = () => import('@/pages/Dictresult.vue')


export default {
    path: '/dictresult',
    component: DefaultLayout,
    children: [
        {
            path: '',
            name:'Результаты диктанта',
            meta:{
                title:'Результаты диктанта'
            },
            component: Dictresult
        }
    ]
}